import { createClient } from '@supabase/supabase-js';
import { getEnvVar, validateEnvironment } from '../utils/envValidation';

// Validate environment on import
const envValidation = validateEnvironment();
if (!envValidation.isValid) {
  console.error('Environment validation errors:', envValidation.errors);
  throw new Error('Invalid environment configuration. Check console for details.');
}

// Log warnings if any
if (envValidation.warnings.length > 0) {
  console.warn('Environment warnings:', envValidation.warnings);
}

const supabaseUrl = getEnvVar('VITE_SUPABASE_URL');
const supabaseAnonKey = getEnvVar('VITE_SUPABASE_ANON_KEY');

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'public'
  },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window?.localStorage
  },
  global: {
    headers: {
      'apikey': supabaseAnonKey
    }
  }
})

export default supabase